<template>
  <div
    class="container_option_item d-flex flex-wrap justify-start align-center rounded gap bordered bg-grey_1 pa-1 mb-2">
    <div class="d-flex flex-sm-row flex-start align-top flex-md-nowrap flex-wrap gap">
      <v-carousel class="thumbnail_carousel" :show-arrows="false"
        :hide-delimiters="article.url_image_2 == '' && article.url_image_3 == ''" height="200" color="white"
        style="width: 200px !important; min-width: 200px">
        <v-carousel-item v-if="article.url_image != ''" :src="article.url_image" cover></v-carousel-item>
        <v-carousel-item v-if="article.url_image_2 != ''" :src="article.url_image_2" cover></v-carousel-item>
        <v-carousel-item v-if="article.url_image_3 != ''" :src="article.url_image_3" cover></v-carousel-item>
      </v-carousel>
      <div class="d-flex flex-column justify-start flex-wrap">
        <div class="text-h5 font-weight-bold">{{ article.nom }}</div>
        <div v-html="article.description"></div>
        <div class="text-body-1">
          <i>Disponible en: {{ list_tailles_text }}</i>
          <v-tooltip v-if="article.get_metadata('popup_info_supp_taille')">
            <u>Guide des tailles</u>
            <div v-html="article.get_metadata('popup_info_supp_taille')"></div>
            <template v-slot:activator="{ props }">
              <v-btn density="compact" size="small" class="ml-2" color="primary-dark" variant="elevated" elevation="1"
                v-bind="props" icon="mdi-help"></v-btn>
            </template>
          </v-tooltip>
        </div>

        <div class="text-h6">
          <span v-if="parseInt(article.prix) > 0">{{ article.prix }}€</span><span v-else>Gratuit</span>
        </div>
        <div v-if="article.sizes.length == 0" class="d-flex align-center gap bg-white bordered px-1 rounded mr-auto">
          <div class="text-body-1">Quantité</div>
          <v-btn size="x-small" v-if="article.quantite_restante > 0" @click="minus_quantity"><v-icon
              icon="mdi-minus"></v-icon>
          </v-btn>
          <div class="text-h6" v-if="article.quantite_restante > 0">{{ article.quantite_souhaite }}</div>
          <div class="text-h6 text-red-darken-4" v-else>Epuisé</div>
          <v-btn size="x-small" v-if="article.quantite_restante > 0" @click="plus_quantity"><v-icon
              icon="mdi-plus"></v-icon>
          </v-btn>
        </div>
        <div v-else class="mr-auto">

          <div v-for="size in article.sizes" :key="size.id"
            class="d-flex align-center gap bg-white bordered px-1 my-1 rounded mr-auto">
            <div class="text-body-1 mr-auto">Taille {{ size.nom }}</div>
            <v-btn v-if="size.quantite_restante > 0" size="x-small" @click="minus_quantity_size(size)"><v-icon
                icon="mdi-minus"></v-icon> </v-btn>
            <div class="text-h6" v-if="size.quantite_restante > 0">{{ size.quantite_souhaite }}</div>
            <div class="text-h6 text-red-darken-4" v-else>Epuisé</div>
            <v-btn v-if="size.quantite_restante > 0" size="x-small" @click="plus_quantity_size(size)"><v-icon
                icon="mdi-plus"></v-icon> </v-btn>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["item"],
  data() {
    return {
      article: {},
      items: [],
    };
  },
  computed: {
    list_tailles_text() {
      let join = this.article.sizes.map((taille) => taille.nom).join(", ");
      return join != "" ? join : "Taille unique";
    },
  },
  methods: {
    get_text_prix(prix) {
      if (prix == 0) {
        return "Gratuit";
      } else {
        return prix + "€";
      }
    },
    minus_quantity_size(size) {
      if (size.quantite_souhaite > 0) {
        size.quantite_souhaite--;
        this.article.quantite_souhaite--;
        this.$emit("updateQuantite", this.article.quantite_souhaite);
      }
    },

    plus_quantity_size(size) {
      if (size.quantite_souhaite < size.quantite_max) {
        size.quantite_souhaite++;
        this.article.quantite_souhaite++;
        this.$emit("updateQuantite", this.article.quantite_souhaite);
      }
    },

    minus_quantity() {
      if (this.article.quantite_souhaite > 0) {
        this.article.quantite_souhaite--;
        this.$emit("updateQuantite", this.article.quantite_souhaite);
      }
    },
    plus_quantity() {
      if (this.article.quantite_souhaite < this.article.quantite_restante) {
        this.article.quantite_souhaite++;
        this.$emit("updateQuantite", this.article.quantite_souhaite);
      }
    },
    get_max() {
      let max = 10;
      if (this.article.metadatas.quantite_max) {
        max = parseInt(this.article.metadatas.quantite_max);
      }
      return max;
    },
    build_quantity_items() {
      let max = 10;
      if (this.article.metadatas.quantite_max) {
        max = parseInt(this.article.metadatas.quantite_max);
      }
      for (let i = 0; i < max; i++) {
        this.items.push(i);
      }
    },
  },
  created() {
    this.article = this.item;
    this.build_quantity_items();
  },
};
</script>

<style lang="scss" scoped>
.image_article {
  width: 50px;
  height: auto;
}
</style>